/* jshint ignore:start */

'use strict';

(function (window, document, $) {
    // Global vars
    var mainNav = $('.fn-main-nav > ul');
    var hasSub  = mainNav.children('.menu-item-has-children');

    hasSub.hover(
        function() {
            enter($(this));
        }, function() {
            leave($('.fn-selma-mega').find('div[data-mega-item="'+ $(this).attr('class').split(' ').pop() +'"]'));
        }
    );

    $('.fn-main-nav > ul > li').not('.menu-item-has-children').hover(
        function() {
            slideUp($('.fn-selma-mega'));
        }
    )

    function slideDown(elem) {
        $(elem).stop().animate({
            'top': '85px'
        }, 300);
    }

    function slideUp(elem) {
        $(elem).stop().animate({
            'top': '-550px'
        }, 300);
    }
    var timer;
    function enter(elem) {
        if (!timer) {
            timer = window.setTimeout(function() {
                timer = null;
                
                var target     = elem.attr('class').split(' ').pop();
                var elemHeight = $('.fn-selma-mega').find('div[data-mega-item="'+ target +'"]').height();
                
                $('.fn-selma-mega').find('.selma-mega__item').css({
                    'display': 'none'
                });

                // Set mega height depending on selected
                $('.fn-selma-mega').css({
                    'height': '300px'
                });

                $('body').addClass('mega-active');

                $('.fn-selma-mega').css({
                    'top': '-550px'
                });
                
                slideDown($('.fn-selma-mega'));

                $('.fn-selma-mega').find('div[data-mega-item="'+ target +'"]').css({            
                    'display': 'table'
                });            

                $('.fn-main-nav').addClass('is-active');  
            }, 500);
        }      
    }

    function leave(megaItem) {
        if (timer) {
            window.clearTimeout(timer);
            timer = null;
        } else {
            var mega  = $('.fn-selma-mega');
            var close = $('.fn-close-mega');
            
            mega.mouseleave(function() {
                slideUp(mega);
                
                $(megaItem).css({
                    'display': 'none'
                });            
            });

            close.on('click', function() {
                slideUp(mega);

                $(megaItem).css({
                    'display': 'none'
                });            
            }); 
        }
    }

    function clear() {
        $('body').removeClass('mega-active');
        $('.fn-main-nav').removeClass('is-active');
        $('.fn-selma-mega').find('.selma-mega__item').css({
            'opacity': 0,
            'visibility': 'hidden'
        });
    }

    $(document).keyup(function(e) {
        if ($('body').hasClass('mega-active')) {
            if (e.keyCode === 27) {
                clear();
            }
        }
    });
})(window, document, jQuery);